import { IWidgetType } from '../IWidgetType';
import { ButtonWidgetType } from './advanced/buttons/ButtonWidget.type';
import { CompanyWidgetType } from './advanced/company/CompanyWidget.type';
import { ConfirmWidgetType } from './advanced/confirm/ConfirmWidget.type';
import { PaymentRowWidgetType } from './advanced/payment-row/PaymentRowWidget.type';
import { RepeatControllerWidgetType } from './advanced/repeat-controller/RepeatControllerWidget.type';
import { RepeatableWidgetType } from './advanced/repeatable/RepeatableWidget.type';
import { SubsectionWidetType } from './advanced/subsection/SubsectionWidget.type';
import { SwitchWidgetType } from './advanced/switch/SwitchWidget.type';
import { TableInputWidgetType } from './advanced/table-input/TableInputWidget.type';
import { ComputedBooleanWidgetType } from './computed/boolean/ComputedBooleanWidget.type';
import { ComputedNumberWidgetType } from './computed/number/ComputedNumberWidget.type';
import { ComputedStringWidgetType } from './computed/string/ComputedStringWidget.type';
import { ColumnWidgetType } from './containers/column/ColumnWidget.type';
import { QuestionWidgetType } from './containers/question/QuestionWidget.type';
import { RowWidgetType } from './containers/row/RowWidget.type';
import { DividerWidgetType } from './graphics/divider/DividerWidget.type';
import { InfoWidgetType } from './graphics/info/InfoWidget.type';
import { PageWidgetType } from './graphics/page';
import { PageBreakWidgetType } from './graphics/page-break/PageBreakWidget.type';
import { ParagraphWidgetType } from './graphics/paragraph/ParagraphWidget.type';
import { SecondaryResumeWidgetType } from './graphics/secondary-resume/SecondaryResumeWidget.type';
import { AsyncSelectWidgetType } from './inputs/async-select';
import { AsyncTableWidgetType } from './inputs/async-table/AsyncTableWidget.type';
import { AsyncValueWidgetType } from './inputs/async-value/AsyncValueWidget.type';
import { BooleanWidgetType } from './inputs/boolean/BooleanWidget.type';
import { CurrencyWidgetType } from './inputs/currency/CurrencyWidget.type';
import { DateWidgetType } from './inputs/date/DateWidget.type';
import { HiddenWidgetType } from './inputs/hidden/HiddenWidget.type';
import { MultiSelectWidgetType } from './inputs/multi-select/MultiSelectWidget.type';
import { NumberWidgetType } from './inputs/number/NumberWidget.type';
import { SingleSelectWidgetType } from './inputs/single-select/SingleSelectWidget.type';
import { TextWidgetType } from './inputs/text/TextWidget.type';

export function getAllWidgetTypes(): Array<IWidgetType<any>> {
  return [
    // Computed
    ComputedBooleanWidgetType,
    ComputedNumberWidgetType,
    ComputedStringWidgetType,
    ConfirmWidgetType,
    // Containers
    RowWidgetType,
    ColumnWidgetType,
    QuestionWidgetType,
    RepeatableWidgetType,
    SubsectionWidetType,
    CompanyWidgetType,
    // Graphics
    DividerWidgetType,
    PageBreakWidgetType,
    SecondaryResumeWidgetType,
    PageWidgetType,
    ParagraphWidgetType,
    InfoWidgetType,
    // Input
    BooleanWidgetType,
    CurrencyWidgetType,
    DateWidgetType,
    MultiSelectWidgetType,
    NumberWidgetType,
    SingleSelectWidgetType,
    AsyncSelectWidgetType,
    AsyncValueWidgetType,
    AsyncTableWidgetType,
    TextWidgetType,
    TableInputWidgetType,
    RepeatControllerWidgetType,
    HiddenWidgetType,
    SwitchWidgetType,
    // CompetenceWidgetType,
    // Azioni
    ButtonWidgetType,
    // Voci di Preventivo
    ...(process.env.BUILD_FLAGS_PAYMENT_TYPES ? [PaymentRowWidgetType] : []),
  ];
}
